/* Mavella Rewards — 前端交互
   三件事：礼品筛选、兑换弹窗、折扣码复制。
   兑换的实际写入必须走后端（见 README.md）——
   本文件只负责 UI，POST 目标由 window.MAVELLA_REWARDS_ENDPOINT 指定。 */
(function () {
  'use strict';

  /* ---------- 礼品筛选 ---------- */
  function initFilters() {
    var chips = document.querySelectorAll('[data-rewards-filter]');
    var grid = document.querySelector('[data-rewards-grid]');
    if (!chips.length || !grid) return;

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var mode = chip.dataset.rewardsFilter;
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });

        grid.querySelectorAll('.mr-card').forEach(function (card) {
          var kind = card.dataset.kind;
          var locked = card.dataset.locked === 'true';
          var show =
            mode === 'all' ? true :
            mode === 'reach' ? !locked :
            mode === 'physical' ? (kind === 'physical' || kind === 'celeste') :
            mode === 'credit' ? kind === 'credit' : true;
          card.hidden = !show;
        });
      });
    });
  }

  /* ---------- 兑换弹窗 ---------- */
  function initModal() {
    var modal = document.querySelector('[data-rewards-modal]');
    if (!modal) return;

    var confirmPanel = modal.querySelector('[data-rewards-modal-confirm]');
    var successPanel = modal.querySelector('[data-rewards-modal-success]');
    var submit = modal.querySelector('[data-rewards-modal-submit]');
    var current = null;
    var busy = false;
    var lastFocus = null;

    function balance() {
      var el = document.querySelector('.mr-dash__points');
      if (el) return parseInt(el.textContent.replace(/[^\d]/g, ''), 10) || 0;
      var dd = modal.querySelector('.mr-modal__maths dd');
      return dd ? parseInt(dd.textContent.replace(/[^\d]/g, ''), 10) || 0 : 0;
    }

    function open(data) {
      current = data;
      busy = false;
      lastFocus = document.activeElement;

      modal.querySelectorAll('[data-rewards-modal-cost]').forEach(function (n) {
        n.textContent = data.cost;
      });
      modal.querySelector('[data-rewards-modal-name]').textContent = data.name;
      var shot = modal.querySelector('[data-rewards-modal-shot]');
      if (shot) shot.textContent = data.name;

      var after = modal.querySelector('[data-rewards-modal-after]');
      if (after) after.textContent = Math.max(0, balance() - data.cost);

      var ships = modal.querySelector('[data-rewards-modal-ships]');
      if (ships) ships.hidden = data.kind === 'credit';

      var tpl = submit.dataset.labelTemplate;
      if (tpl) submit.textContent = tpl.replace('%COST%', data.cost);
      submit.disabled = false;

      confirmPanel.hidden = false;
      successPanel.hidden = true;
      modal.hidden = false;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      submit.focus();
    }

    function close() {
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.body.style.overflow = '';
      current = null;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function fail(message) {
      busy = false;
      submit.disabled = true;
      submit.textContent = message;
    }

    function succeed(newBalance) {
      var title = successPanel.querySelector('[data-rewards-success-title]');
      if (title && current) {
        title.textContent = (title.dataset.template || '%REWARD%').replace('%REWARD%', current.name);
      }
      var bal = successPanel.querySelector('[data-rewards-success-balance]');
      if (bal) bal.textContent = newBalance;
      confirmPanel.hidden = true;
      successPanel.hidden = false;
      successPanel.querySelector('.mr__btn').focus();
    }

    document.querySelectorAll('[data-rewards-redeem]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open({
          key: btn.dataset.rewardKey,
          cost: parseInt(btn.dataset.rewardCost, 10) || 0,
          name: btn.dataset.rewardName || '',
          kind: btn.dataset.rewardKind || 'physical'
        });
      });
    });

    modal.querySelectorAll('[data-rewards-modal-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    submit.addEventListener('click', function () {
      if (!current || busy) return;
      busy = true;
      submit.disabled = true;

      var endpoint = window.MAVELLA_REWARDS_ENDPOINT;
      if (!endpoint) {
        // 没有写入端点时绝不伪造成功态 —— 否则顾客以为兑换成功，后台却没扣分。
        console.error('[mavella-rewards] MAVELLA_REWARDS_ENDPOINT 未配置，兑换已阻止。');
        fail(submit.dataset.labelUnavailable || 'Unavailable');
        return;
      }

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          reward: current.key,
          cost: current.cost,
          idempotency_key: current.key + ':' + Date.now()
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('redeem failed: ' + r.status);
          return r.json();
        })
        .then(function (data) {
          succeed(typeof data.balance === 'number' ? data.balance : Math.max(0, balance() - current.cost));
        })
        .catch(function (err) {
          console.error('[mavella-rewards]', err);
          busy = false;
          submit.disabled = false;
          var tpl = submit.dataset.labelTemplate;
          submit.textContent = (tpl ? tpl.replace('%COST%', current.cost) : submit.textContent);
        });
    });
  }

  /* ---------- 折扣码复制 ---------- */
  function initCopy() {
    document.querySelectorAll('[data-rewards-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.dataset.rewardsCopy;
        var hint = btn.querySelector('[data-rewards-copy-hint]');
        var done = function () {
          if (!hint) return;
          var original = hint.textContent;
          hint.textContent = hint.dataset.copied || code;
          setTimeout(function () { hint.textContent = original; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    });
  }

  function init() {
    initFilters();
    initModal();
    initCopy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor 里重新加载 section 后重新绑定
  document.addEventListener('shopify:section:load', init);
})();
